import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import { hasDuplicateElementName } from './util';
import { BUILTIN_DATA_TYPES, type IDataType } from '../../../stores/model/metamodel/data_type';

/**
 * Check if there are duplicate data types (i.e. data types with the same name).
 */
class DataTypeDuplicateCheck extends Check<IDataType> {
  static description = 'Check for duplicate data types';

  check(): Report {
    this.report = new Report();
    if (BUILTIN_DATA_TYPES.includes(this.element.name)) {
      this.report.addMessage(
        MessageType.ERROR,
        'Data types with the same name found.',
        this,
        this.element
      );
    } else if (hasDuplicateElementName(this.model.dataTypes, this.element)) {
      this.report.addMessage(
        MessageType.ERROR,
        'Data types with the same name found.',
        this,
        this.element
      );
    } else {
      this.report.addMessage(
        MessageType.INFORMATION,
        'No data types with the same name found.',
        this,
        this.element
      );
    }
    return this.report;
  }
}

export default DataTypeDuplicateCheck;
